import request from '@/config/axios'

export const apiLogin = (data) => {
  return request.post({
    url: '/api/sys/user/login',
    data
  })
}

// 用户注册
export const apiRegister = (data) => {
  return request.post({
    url: '/api/sys/user/reg',
    data
  })
}

export const loginOutApi = () => {
  return request.post({ url: '/api/sys/user/logout' })
}

export const routesApi = (data: any) => {
  return request.post({
    url: '/api/sys/menu/routes',
    data
  })
}
export const userSMSCode = (data: any) => {
  return request.post({
    url: '/api/sys/user/sms/code',
    data
  })
}
export const userSMSLogin = (data: any) => {
  return request.post({
    url: '/api/sys/user/sms/login',
    data
  })
}
export const userAuth = (data: any) => {
  return request.post({
    url: '/api/sys/user/auth',
    data
  })
}

//shareLogin 页面免登录接口
export const noLogin = (params: any) => {
  return request.get({
    url: '/api/sys/user/loginByWxLeaderCode',
    params
  })
}